var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.542 90 l -4.901 -16.589 c -0.237 -0.62 -0.55 -1.297 -0.907 -1.944 c -0.356 -0.648 -0.761 -1.276 -1.204 -1.865 c -0.442 -0.588 -0.932 -1.153 -1.456 -1.677 c -0.523 -0.522 -1.087 -1.012 -1.677 -1.455 c -0.587 -0.441 -1.215 -0.847 -1.865 -1.205 c -0.647 -0.356 -1.325 -0.669 -2.015 -0.93 L 0 59.459 l 16.589 -4.901 c 0.618 -0.236 1.296 -0.548 1.945 -0.906 c 0.65 -0.358 1.277 -0.764 1.864 -1.205 c 0.59 -0.443 1.154 -0.933 1.677 -1.455 c 0.524 -0.524 1.013 -1.088 1.455 -1.677 c 0.444 -0.59 0.849 -1.218 1.205 -1.865 c 0.357 -0.647 0.669 -1.325 0.93 -2.015 l 4.877 -16.518 l 4.901 16.589 c 0.239 0.622 0.551 1.3 0.907 1.945 c 0.355 0.646 0.761 1.274 1.205 1.865 c 0.441 0.588 0.931 1.153 1.455 1.677 c 0.523 0.522 1.087 1.012 1.677 1.455 c 0.587 0.441 1.215 0.847 1.865 1.205 c 0.649 0.357 1.326 0.669 2.014 0.929 l 16.518 4.878 l -16.588 4.9 c -0.619 0.237 -1.297 0.55 -1.945 0.907 c -0.65 0.358 -1.277 0.764 -1.865 1.205 c -0.59 0.443 -1.154 0.933 -1.677 1.455 c -0.524 0.524 -1.013 1.088 -1.455 1.676 c -0.445 0.592 -0.85 1.219 -1.205 1.865 c -0.349 0.634 -0.658 1.301 -0.918 1.982 L 30.542 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F86B4F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.086 41.831 L 65.59 29.997 c -0.14 -0.359 -0.334 -0.78 -0.554 -1.18 c -0.223 -0.404 -0.474 -0.794 -0.749 -1.159 c -0.275 -0.367 -0.58 -0.717 -0.904 -1.041 c -0.324 -0.324 -0.673 -0.628 -1.04 -0.904 c -0.367 -0.276 -0.756 -0.527 -1.158 -0.749 s -0.824 -0.416 -1.252 -0.578 l -11.762 -3.472 l 11.833 -3.496 c 0.357 -0.138 0.779 -0.333 1.182 -0.554 c 0.401 -0.221 0.79 -0.472 1.156 -0.748 c 0.368 -0.276 0.717 -0.58 1.04 -0.903 c 0.325 -0.324 0.629 -0.674 0.905 -1.042 c 0.274 -0.365 0.526 -0.755 0.749 -1.158 c 0.221 -0.4 0.415 -0.821 0.578 -1.251 L 69.086 0 l 3.495 11.834 c 0.14 0.359 0.334 0.78 0.554 1.18 c 0.223 0.404 0.474 0.794 0.749 1.159 c 0.275 0.367 0.58 0.717 0.904 1.041 c 0.324 0.324 0.673 0.628 1.04 0.904 c 0.367 0.276 0.756 0.527 1.158 0.749 c 0.402 0.221 0.824 0.416 1.252 0.578 L 90 20.915 l -11.833 3.496 c -0.357 0.138 -0.779 0.333 -1.182 0.554 c -0.401 0.221 -0.79 0.472 -1.156 0.748 c -0.368 0.276 -0.717 0.58 -1.04 0.903 c -0.325 0.324 -0.629 0.674 -0.905 1.042 c -0.274 0.365 -0.526 0.755 -0.749 1.158 c -0.215 0.39 -0.405 0.799 -0.565 1.217 L 69.086 41.831 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F86B4F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.e004b3680b13da9c173000bc7be42750.svg";
export { ForwardRef as ReactComponent };